module.exports = __webpack_public_path__ + "docs/guide_buy.pdf";